(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfcm-image-banners"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('p1-sale-banners')) {
    customElements.define('p1-sale-banners', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.p1-sale-banners__track');
        const buttons = Array.from(this.querySelectorAll('[data-slide]'));
        buttons.forEach((button, index) => button.addEventListener('click', () => {
          track.scrollTo({ left: index * track.clientWidth, behavior: 'auto' });
          buttons.forEach((item, itemIndex) => item.setAttribute('aria-pressed', String(itemIndex === index)));
        }));
        track.addEventListener('scroll', () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          buttons.forEach((item, itemIndex) => item.setAttribute('aria-pressed', String(itemIndex === index)));
        }, { passive: true });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
